module.exports = __webpack_public_path__ + "images/stickers/taco-love.7ce9fac1da3d211929b5.png";